import MedicalRecordsModal from "./MedicalRecordsModal";

export default MedicalRecordsModal;